"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sigHashAll = void 0;
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
const blake2b_1 = require("@nervosnetwork/ckb-sdk-utils/lib/crypto/blake2b");
const constants_1 = require("../constants");
const sigHashAll = (transaction) => {
    const witnessGroup = transaction.witnesses;
    if (!witnessGroup.length) {
        throw new Error('WitnessGroup cannot be empty');
    }
    if (typeof witnessGroup[0] !== 'object') {
        throw new Error('The first witness in the group should be type of WitnessArgs');
    }
    const transactionHash = (0, ckb_sdk_utils_1.rawTransactionToHash)(transaction);
    const emptyWitness = Object.assign(Object.assign({}, witnessGroup[0]), { lock: `0x${'0'.repeat(constants_1.SECP256R1_PUBKEY_SIG_LEN)}` });
    const serializedEmptyWitnessBytes = (0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.serializeWitnessArgs)(emptyWitness));
    const serializedEmptyWitnessSize = serializedEmptyWitnessBytes.length;
    const hash = (0, blake2b_1.default)(32, null, null, ckb_sdk_utils_1.PERSONAL);
    hash.update((0, ckb_sdk_utils_1.hexToBytes)(transactionHash));
    hash.update((0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.toUint64Le)(`0x${serializedEmptyWitnessSize.toString(16)}`)));
    hash.update(serializedEmptyWitnessBytes);
    witnessGroup.slice(1).forEach(w => {
        const bytes = (0, ckb_sdk_utils_1.hexToBytes)(typeof w === 'string' ? w : (0, ckb_sdk_utils_1.serializeWitnessArgs)(w));
        hash.update((0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.toUint64Le)(`0x${bytes.length.toString(16)}`)));
        hash.update(bytes);
    });
    const message = `${hash.digest('hex')}`;
    return message;
};
exports.sigHashAll = sigHashAll;
